<template>
  <Comments :comments="comments" @comment:deleted="removeComment">
    <template #default="{ scrollToEnd }">
      <div v-if="createFormVisible" class="sticky bottom-0 bg-white p-4 rounded border">
        <CommentForm :submit-action="submitComment" @submit:resolved="createFormVisible = false">
          <button type="button" class="btn btn-ghost ml-2" @click="createFormVisible = false">
            Cancel
          </button>
        </CommentForm>
      </div>
      <button
        v-else
        type="button"
        class="btn btn-success w-full sticky bottom-0"
        @click="
          () => {
            createFormVisible = true;
            $nextTick(() => {
              scrollToEnd();
            });
          }
        "
      >
        Add Comment
      </button>
    </template>
  </Comments>
</template>

<script>
import Comments from '@/components/Comments/Comments.vue';
import CommentForm from '@/components/Comments/CommentForm.vue';

const STATUS_IDLE = 'STATUS_IDLE';
const STATUS_PENDING = 'STATUS_PENDING';
const STATUS_RESOLVED = 'STATUS_RESOLVED';
const STATUS_REJECTED = 'STATUS_REJECTED';

export default {
  name: 'OrderItemComments',

  components: {
    Comments,
    CommentForm,
  },

  props: {
    orderItemId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loadStatus: STATUS_IDLE,
      createFormVisible: false,
    };
  },

  computed: {
    comments() {
      return this.$store.getters['ui/orderItemComments/comments'];
    },
  },

  created() {
    this.loadComments();
  },

  destroyed() {
    this.$store.dispatch({
      type: 'ui/orderItemComments/reset',
    });
  },

  methods: {
    async loadComments() {
      this.loadStatus = STATUS_PENDING;
      try {
        await this.$store.dispatch({
          type: 'ui/orderItemComments/load',
          orderItemId: this.orderItemId,
        });

        this.loadStatus = STATUS_RESOLVED;
      } catch (error) {
        this.loadStatus = STATUS_REJECTED;
      }
    },
    submitComment(body) {
      return this.$store
        .dispatch({
          type: 'ui/orderItemComments/store',
          orderItemId: this.orderItemId,
          body,
        })
        .then((response) => {
          this.commentFormVisible = false;
          return Promise.resolve(response);
        })
        .catch((error) => Promise.reject(error));
    },
    removeComment(comment) {
      this.$store.dispatch({
        type: 'ui/orderItemComments/remove',
        commentId: comment.uuid,
        forget: true,
      });
    },
  },
};
</script>
